import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MicrosoftIntuneService } from '../../service';

export type EndpointSecurityPolicyDefinitionConfig =
  typeof EndpointSecurityPolicyDefinitionConfig._.Config;

export const EndpointSecurityPolicyDefinitionConfig = IntegrationConfig.make({
  service: MicrosoftIntuneService,
  name: Integration_Handler_Names_Enum.EndpointSecurityPolicyDefinition,
  configSchema: z.object({
    policyId: z.uuid(),
  }),
});
